/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { CompilerInjectable } from './injectable';
/**
 * @abstract
 */
export class SummaryResolver {
    /**
     * @abstract
     * @param {?} fileName
     * @return {?}
     */
    isLibraryFile(fileName) { }
    /**
     * @abstract
     * @param {?} fileName
     * @return {?}
     */
    getLibraryFileName(fileName) { }
    /**
     * @abstract
     * @param {?} reference
     * @return {?}
     */
    resolveSummary(reference) { }
    /**
     * @abstract
     * @param {?} filePath
     * @return {?}
     */
    getSymbolsOf(filePath) { }
    /**
     * @abstract
     * @param {?} reference
     * @return {?}
     */
    getImportAs(reference) { }
    /**
     * @abstract
     * @param {?} summary
     * @return {?}
     */
    addSummary(summary) { }
}
export class JitSummaryResolver {
    constructor() {
        this._summaries = new Map();
    }
    /**
     * @param {?} fileName
     * @return {?}
     */
    isLibraryFile(fileName) { return false; }
    /**
     * @param {?} fileName
     * @return {?}
     */
    getLibraryFileName(fileName) { return null; }
    /**
     * @param {?} reference
     * @return {?}
     */
    resolveSummary(reference) {
        return this._summaries.get(reference) || null;
    }
    /**
     * @param {?} filePath
     * @return {?}
     */
    getSymbolsOf(filePath) { return []; }
    /**
     * @param {?} reference
     * @return {?}
     */
    getImportAs(reference) { return reference; }
    /**
     * @param {?} summary
     * @return {?}
     */
    addSummary(summary) { this._summaries.set(summary.symbol, summary); }
}
JitSummaryResolver.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
JitSummaryResolver.ctorParameters = () => [];
function JitSummaryResolver_tsickle_Closure_declarations() {
    /** @type {?} */
    JitSummaryResolver.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    JitSummaryResolver.ctorParameters;
    /** @type {?} */
    JitSummaryResolver.prototype._summaries;
}
//# sourceMappingURL=summary_resolver.js.map